import { useCallback, useRef, useState } from 'react';
import { Avatar } from './Person';
import { PopNotFound, PopSearch } from './Popover';
import { useDismiss } from './useDismiss';

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w.charAt(0))
    .join('')
    .toUpperCase();

/**
 * Пилюля ответственного `.own` (кит 2.14, OwnerPill): аватар, имя, шеврон;
 * клик — смена. Поповер, поэтому ставится в шапке карточки, а не в окне.
 * `noneOption` — явный пункт «Ничья» у заявки (БЛ M3 5.11); без него
 * у назначенного есть «Снять ответственного». `meId` помечает себя «вы».
 * Поиск по имени — в любом списке (кит 2.15); «Ничья» и «Снять» видны всегда.
 */
export function OwnerPill({
  owner,
  users,
  onChange,
  emptyLabel = 'Ответственный не назначен',
  noneOption,
  meId,
}: {
  owner: { id: string; fullName: string } | null;
  users: { id: string; fullName: string }[];
  onChange: (userId: string | null) => void;
  emptyLabel?: string;
  noneOption?: string;
  meId?: string;
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const wrap = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(open, close, wrap);
  const q = query.trim().toLowerCase();
  const visible = q ? users.filter((u) => u.fullName.toLowerCase().includes(q)) : users;
  const pick = (id: string | null) => {
    close();
    if (id !== (owner?.id ?? null)) onChange(id);
  };
  return (
    <div className="wrapctl" ref={wrap}>
      <button
        type="button"
        className="own"
        aria-expanded={open}
        onClick={() => {
          setQuery('');
          setOpen((v) => !v);
        }}
      >
        <Avatar initials={owner ? initials(owner.fullName) : '—'} size={22} />
        {owner?.fullName ?? emptyLabel}
        <svg>
          <use href="#chev" />
        </svg>
      </button>
      {open ? (
        <div className="pop rt">
          <PopSearch value={query} onChange={setQuery} />
          {!visible.length ? <PopNotFound /> : null}
          {visible.map((u) => (
            <div key={u.id} className={u.id === owner?.id ? 'op on' : 'op'} onClick={() => pick(u.id)}>
              <Avatar initials={initials(u.fullName)} size={22} />
              {u.fullName}
              {u.id === meId ? <span className="sb">вы</span> : null}
            </div>
          ))}
          {noneOption ? (
            <div className={owner ? 'op' : 'op on'} onClick={() => pick(null)}>
              <Avatar initials="—" size={22} />
              {noneOption}
            </div>
          ) : owner ? (
            <div className="op" onClick={() => pick(null)}>
              Снять ответственного
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
